import { useEffect } from "react";

export const useExitPrompt = (condition = true) => {
  useEffect(() => {
    const listener = (event: BeforeUnloadEvent) => {
      // disabled in dev mode
      if (condition && !import.meta.env.DEV) {
        event.preventDefault();
        // Included for legacy support, e.g. Chrome/Edge < 119
        event.returnValue = true;
      }
    };
    // when user tries to close the browser window
    window.addEventListener("beforeunload", listener);
    // Should be triggered when user uses forward/back browser buttons
    // when user enters a new URL manually
    window.addEventListener("hashchange", listener);
    return () => {
      window.removeEventListener("beforeunload", listener);
      window.removeEventListener("hashchange", listener);
    };
  }, [condition]);
};
